export const getSourceSite = () => {
    return process.env.NEXT_PUBLIC_SOURCE_SITE.replace(/ /g, "").toLowerCase();
};
